import { t } from "@/i18n-js/instance";

export interface Shortcut {
  keys: string[];
  name: string;
  permissions?: string[];
}

export interface ShortcutCategory {
  category: string;
  shortcuts: Shortcut[];
}

export const KEYBOARD_SHORTCUTS_DATA: ShortcutCategory[] = [
  {
    get category() {
      return t("header_v3.shortcuts.category.basics");
    },
    shortcuts: [
      {
        get name() {
          return t("header_v3.shortcuts.name.open_search");
        },
        keys: ["cmd", "K"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.open_keyboard_shortcuts");
        },
        keys: ["cmd", "/"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.toggle_light_dark_mode");
        },
        keys: ["cmd", "alt", "u"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.open_notifications");
        },
        keys: ["alt", "n"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.open_direct_messages");
        },
        keys: ["alt", "m"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.open_chat_threads");
        },
        keys: ["alt", "t"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.open_bookmarks");
        },
        keys: ["alt", "b"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.customize_theme");
        },
        keys: ["alt", "c", "t"],
        permissions: ["admin"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.customize_notifications");
        },
        keys: ["alt", "c", "n"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.edit_profile");
        },
        keys: ["alt", "g", "p"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.view_profile");
        },
        keys: ["alt", "g", "v"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.write_a_post");
        },
        keys: ["cmd", "shift", "p"],
      },
    ],
  },
  {
    get category() {
      return t("header_v3.shortcuts.category.community_switching");
    },
    shortcuts: [
      {
        get name() {
          return t("header_v3.shortcuts.name.a_specific_community");
        },
        keys: ["alt", "g", "1-9"],
      },
    ],
  },
  {
    get category() {
      return t("header_v3.shortcuts.category.navigation");
    },
    shortcuts: [
      {
        get name() {
          return t("header_v3.shortcuts.name.add_space");
        },
        keys: ["alt", "shift", "n"],
        permissions: ["admin", "moderator"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.add_space_group");
        },
        keys: ["alt", "shift", "g"],
        permissions: ["admin"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.home_feed");
        },
        keys: ["alt", "g", "h"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.go_live");
        },
        keys: ["alt", "g", "l"],
        permissions: ["admin"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.member_directory");
        },
        keys: ["alt", "g", "m"],
        permissions: ["admin"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.course_directory");
        },
        keys: ["alt", "g", "c"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.settings");
        },
        keys: ["alt", "g", "s"],
        permissions: ["admin"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.event_directory");
        },
        keys: ["alt", "g", "e"],
      },
    ],
  },
  {
    get category() {
      return t("header_v3.shortcuts.category.text_editor");
    },
    shortcuts: [
      {
        get name() {
          return t("header_v3.shortcuts.name.slash_commands");
        },
        keys: ["/"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.emoji_autocomplete");
        },
        keys: [":"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.mentions_autocomplete");
        },
        keys: ["@"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.copy");
        },
        keys: ["cmd", "C"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.cut");
        },
        keys: ["cmd", "X"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.paste");
        },
        keys: ["cmd", "V"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.paste_without_formatting");
        },
        keys: ["cmd", "shift", "V"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.undo");
        },
        keys: ["cmd", "Z"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.redo");
        },
        keys: ["cmd", "shift", "Z"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.add_a_line_break");
        },
        keys: ["shift", "enter"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.bold");
        },
        keys: ["cmd", "B"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.italic");
        },
        keys: ["cmd", "I"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.underline");
        },
        keys: ["cmd", "U"],
      },
      {
        get name() {
          return t("header_v3.shortcuts.name.strikethrough");
        },
        keys: ["cmd", "shift", "X"],
      },
    ],
  },
];
